import { ICellRendererParams, GridOptions } from "ag-grid-community";
import { Component } from "react";
import { ICellRendererReactComp } from "ag-grid-react";
import { Contact } from "types/portfolio";
import {
  Chip,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Typography,
  Divider,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import dynamic from "next/dynamic";
import MButton from "components/momentum/MButton";
import { AgGridReact } from "ag-grid-react/lib/agGridReact";
import { AxiosInstance } from "axios";
import AuthCheck from "components/app/AuthCheck";
import { FEATURE_KEY } from "constant";

interface ContactsRendererState {
  open: boolean;
}

interface ContactsRendererProps extends ICellRendererParams {
  axios: AxiosInstance;
}

class ContactsRenderer
  extends Component<ContactsRendererProps, ContactsRendererState>
  implements ICellRendererReactComp
{
  private gridOptions: GridOptions;

  constructor(props: ContactsRendererProps) {
    super(props);
    this.state = { open: false };

    this.handleClick = this.handleClick.bind(this);
    this.download = this.download.bind(this);
    this.gridOptions = {
      columnDefs: [
        {
          headerName: "Name",
          valueGetter: (params) =>
            !!params.data ? `${params.data.firstName} ${params.data.lastName}` : "",
        },
        {
          headerName: "Phone Number",
          field: "phoneNumber",
        },
        {
          headerName: "Email",
          field: "email",
        },
        {
          headerName: "Role(s)",
          field: "type",
        },
        {
          headerName: "Title",
          field: "jobFunction",
        },
        {
          headerName: "Department",
          field: "department",
        },
      ],
      rowData: this.props.data.contacts ?? [],
      defaultColDef: {
        sortable: true,
        minWidth: 120,
        resizable: true,
      },
    };
  }

  public refresh() {
    return false;
  }

  private handleClick = (open: boolean) => () => {
    this.setState({ open });
  };

  private download() {
    this.props.axios
      .post("/api/portfolio/contactsDownload", {
        accounts: [this.props.data],
      })
      .then((res) => {
        saveAs(
          new Blob([res.data], {
            type: res.headers["content-type"],
          }),
          res.headers.filename
        );
      });
  }

  public render() {
    const contacts: Contact[] = this.props.data.contacts;
    const { open } = this.state;
    if (contacts.length > 0) {
      const primary = contacts[0];
      return (
        <>
          <div style={{ display: "flex", alignItems: "center" }}>
            {`${primary.firstName} ${primary.lastName}`}
            {contacts?.length > 0 ? (
              <Chip
                label={`+${contacts.length}`}
                size="small"
                style={{ marginLeft: 4, height: 18 }}
                onClick={this.handleClick(true)}
              />
            ) : null}
          </div>
          {contacts?.length > 0 ? (
            <Dialog
              open={open}
              onClose={this.handleClick(false)}
              fullWidth={true}
              maxWidth="md"
            >
              <DialogTitle>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="h4">Contacts</Typography>
                  <IconButton
                    onClick={this.handleClick(false)}
                    size="small"
                  >
                    <Close fontSize="small" />
                  </IconButton>
                </div>
                <AuthCheck id={FEATURE_KEY.PORTFOLIO_CONTACTS_DOWNLOAD}>
                  <MButton
                    onClick={this.download}
                    buttonType="blue"
                  >
                    Export
                  </MButton>
                </AuthCheck>
              </DialogTitle>
              <DialogContent dividers={true}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    height: 48,
                    marginBottom: 12,
                  }}
                >
                  <div>
                    <span style={{ color: "#999", fontWeight: "bold" }}>Account Name</span>
                    <span style={{ marginLeft: 8 }}>{this.props.data?.accountName}</span>
                  </div>
                  <div>
                    <span style={{ color: "#999", fontWeight: "bold" }}>Account ID</span>
                    <span style={{ marginLeft: 8 }}>{this.props.data?.accountId}</span>{" "}
                  </div>
                </div>
                <Divider />

                <div
                  className="ag-theme-material"
                  style={{
                    height: "35vh",
                    width: "100%",
                  }}
                >
                  <AgGridReact gridOptions={this.gridOptions} />
                </div>
              </DialogContent>
            </Dialog>
          ) : null}
        </>
      );
    }
    return "";
  }
}

export default dynamic(() => Promise.resolve(ContactsRenderer), { ssr: false });
